import styled, {
  css,
  DefaultTheme,
  Interpolation,
  ThemedStyledProps,
} from 'styled-components';
import colors from '../../../helpers/colors';

type ValueProps = {
  value?: number | string;
};

type ValueInterpolation = Interpolation<ThemedStyledProps<ValueProps, DefaultTheme>>;

export const Container = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: ${({ theme }) => theme.inputRadius};
  pointer-events: none;
  overflow: hidden;
`;

export const Underline = styled.div`
  height: 2px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  transform: scaleX(0);
  transition: transform 0.2s ease-out;
`;

export const underlineOnValue: ValueInterpolation = ({ value }) =>
  !!value &&
  css`
    & ~ ${Container} ${Underline}:nth-child(1) {
      transform: scaleX(1);
      background-color: ${colors.neutral03};
    }
  `;

export const underlineOnFocus = css`
  &:focus-visible {
    & ~ ${Container} ${Underline}:nth-child(2) {
      transform: scaleX(1);
      background-color: ${colors.core01};
    }
  }
`;
